(function () {

  'use strict';

  function pxGroupContextMenu(
    $timeout, $window
  ) {
    return {
      restrict: 'E',
      scope: {
        context: '=context',
        resource: '=resource',
        auxiliaries: '=auxiliaries',
        selectedTab: '=selectedTab',
        contextPosition: '=contextPosition',
        callback: '&callback',
        updateParent: '&updateParent'
      },

      templateUrl: 'app/components/groupProperties/_groupContextMenu/groupContextMenu.template.html',
      link: function (scope, element, attrs) {

        (function () {
          if (scope.contextPosition) {
            initContextContent();
          }
        })();

        scope.$watch(function () {
          return scope.contextPosition;
        }, function () {
          if (scope.contextPosition) {
            initContextContent();
          }
        });

        function initContextContent() {
          checkValidPostion(scope.contextPosition.left, scope.contextPosition.top);
        };

        function checkValidPostion(left, top) {
          const offsetX = 60;
          const offsetY = 100;

          left -= offsetX;
          const containerWidth = angular.element('.container').innerWidth();

          $timeout(function () {
            const menuHeight = angular.element('.context-content-container').innerHeight();
            const menuWidth = angular.element('.context-content-container').innerWidth();

            if ($window.innerHeight <= 768) {
              const screenCenter = $window.innerHeight / 2;
              const menuCenter = menuHeight / 2;
              top = screenCenter - menuCenter;
            } else if ((menuHeight + top) > $window.innerHeight) {
              top = ($window.innerHeight - menuHeight) / 2;
            } else {
              top -= offsetY;
            }

            if (containerWidth <= 1024) {
              const screenCenter = containerWidth / 2;
              const menuCenter = menuWidth / 2;
              left = screenCenter - menuCenter;
            } else if ((menuWidth + left) > containerWidth) {
              left -= menuWidth;
            }

            angular.element('.context-content-container').css({ left, top, display: 'block' });
          });
        }

        scope.closePopup = function (bypass) {
          if (!bypass) {
            scope.callback({ selectedContextMenuItem: null, contextPosition: null, contextContent: null });
          }
        };

        scope.relayUpdateParent = function () {
          scope.updateParent();
        };

        scope.$on('$destroy', function () {
          angular.element('.context-content-container').css({ display: 'none' });
        });

      }
    };
  }

  pxGroupContextMenu.$inject = ['$timeout', '$window'];

  angular
    .module('printix-admin')
    .directive('pxGroupContextMenu', pxGroupContextMenu);

})();
